import RenderYoutubeVideo from "./RenderYoutubeVideo";

export default RenderYoutubeVideo;